import {
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
  Injector,
  Input,
} from '@angular/core';
import { BaseComponent, SnackbarComponent } from '../../../../components';
import { MainTemplate, Tier } from '../../../../models/template';
//marina - add production logging service
import { LogService, PrintService, ProfileService, StyleService } from '../../../../services';
import { LogSource, LogType } from '../../../../models/common';

import {
  ConversionType,
  RedemptionTemplateConfigModel,
  RedemptionsConfigModel,
  TierLevels,
} from '../../../../models/redemption-template.model';
import { InfoModalComponent } from './../../../../components/info-modal/info-modal.component';
import { ConfirmRedeemModalComponent } from '../../../../components/confirm-redeem/confirm-redeem-modal.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';
import { TabType } from '../../../../models/template';
import { DataPointService } from '../../../../services/data-point.service';
import { MatSnackBar } from '@angular/material/snack-bar';

import { TransactionLogService } from '../../../../services/transaction-log.service';
import { AuthService } from '../../../../services/auth.service';
import * as uuid from 'uuid';

@Component({
  selector: 'app-redemption-template',
  templateUrl: './redemption-template.component.html',
  styleUrls: ['./redemption-template.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class RedemptionTemplateComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  @Input() tab?: any;
  @Input() mainTemplate!: MainTemplate;
  @Input() pageLinkIndex!: number;
  @Input() selectTabIndex!: number;

  public isLoading = false;
  public redemptionAmountValue: number = 0;
  public tabType = TabType;
  public redemptionKeyboardButtons = [1, 2, 3, 4, 5, 6, 7, 8, 9];

  public sourceBucket = 'Points';
  public selectedRedeem = 'XtraCredit';

  public conversionType = [
    { title: 'Free play', value: 'freePlay' },
    { title: 'Cash', value: 'cash' },
    { title: 'Dining', value: 'dining' },
    { title: 'Bevarage', value: 'bevarage' },
    { title: 'Race & Sports', value: 'raceAndSports' },
    { title: 'Hotel', value: 'hotel' },
    { title: 'Match Play', value: 'matchPlay' },
  ];

  public styleService: StyleService;
  public profileService: ProfileService;
  public dataPointService: DataPointService;
  public printService: PrintService;

  //add LogService for production redemption logging
  protected logService: LogService;

  private sanitizer: DomSanitizer;
  protected dialog: MatDialog;
  public snackbar: MatSnackBar;

  public dailyLimit: string = "";
  public accountId: string = "";
  protected transactionLogService: TransactionLogService;
  protected authService: AuthService;
  protected transactionVoucherId: string = '';

  constructor(protected override readonly injector: Injector) {
    super(injector);

    this.styleService = this.injector.get(StyleService);
    this.profileService = this.injector.get(ProfileService);
    this.dataPointService = this.injector.get(DataPointService);
    this.sanitizer = this.injector.get(DomSanitizer);
    this.dialog = this.injector.get(MatDialog);
    this.snackbar = this.injector.get(MatSnackBar);
    this.printService = this.injector.get(PrintService);

    this.transactionLogService = this.injector.get(TransactionLogService);
    this.authService = this.injector.get(AuthService);

    //add LogService for production redemption logging
    this.logService = this.injector.get(LogService);

  }

  ngOnInit(): void {}

  public get isEmptyConversionRate() {
    const { rateFrom } = this.getConversioRate();
    return !rateFrom;
  }

  public get playerProfile() {
    return this.profileService.playerProfile;
  }

  public getSourceBucketUcValue(value: string) {
    if (
      value.includes('a_Points.amount') ||
      value.includes('PlayerAccountBalance') ||
      value === 'playerBalance'
    ) {
      return 'pointBalance';
    }
    return value;
  }

  public clearRedemptionAmount() {
    this.redemptionAmountValue = 0;
  }

  public addRedemptionValue(value: number) {
    if (this.isEmptyConversionRate || !this.selectedRedeem.length || this.profileService.playerAccountPointBalance <= 0) {
      return;
    }
    const pointsNedded = this.calculateNeededPointsToRedeem(
      Number(this.redemptionAmountValue.toString() + value)
    ).pointsNeeded;
    if (isNaN(pointsNedded)) {
      return;
    }
    const isValueMoreThanPoints =
      pointsNedded > this.profileService.playerAccountPointBalance;
    if (isValueMoreThanPoints) {
      this.addMaxAmount();
      return;
    }
    this.redemptionAmountValue = Number(
      this.redemptionAmountValue.toString() + value
    );
  }

  public keyboardBackspace(): void {
    const redemptionAmountValueArr = this.redemptionAmountValue
      .toString()
      .split('');

    this.redemptionAmountValue = Number(
      redemptionAmountValueArr.slice(0, -1).join('')
    );
  }

  public openRedeemConfirmation(): void {
    if (!this.redemptionAmountValue) return;

    const page = this.mainTemplate.template.pageLinks[this.pageLinkIndex];
    const templateSettings = page.templateSettings[this.selectTabIndex];
    const config = templateSettings.templateConfig as any;
    const errorCss =
      '.content.info-modal-content .message-text {color: #F14823;}';

    if (config?.minValue && this.redemptionAmountValue < config.minValue) {
        const rawText = this.tab.templateConfig.ivalidMinAmountText;
        const substitutedText = rawText?.replace(/{{minAmount}}/g, String(this.tab.templateConfig.minValue));

        return this.openInfoBlock(
          config.ivalidMinAmountTitle,
          substitutedText,
          '.content.info-modal-content .message-text {color: #F14823;}'
        );
    }

    if (config?.maxValue && this.redemptionAmountValue > config.maxValue) {
        const rawText = this.tab.templateConfig.ivalidMaxAmountText;
        const substitutedText = rawText?.replace(/{{maxAmount}}/g, String(this.tab.templateConfig.maxValue));

        return this.openInfoBlock(
          config.ivalidMaxAmountTitle,
          substitutedText,
          '.content.info-modal-content .message-text {color: #F14823;}'
        );
    }

    this.dailyLimit = config.dailyLimit?.toString();
    this.accountId = config.accountId;

    this.dialog.open(ConfirmRedeemModalComponent, {
      panelClass: 'profile-dialog',
      backdropClass: 'backDropClass',
      height: '18vh',
      width: '100vw',
      data: {
        callback: async () => {
          await this.adjustingRedemptionValues();
        },
        playerId: this.playerProfile.playerId,
        redeemPrefix: config.exchangeText,
        redeemValue: this.redemptionAmountValue,
        pointToReedem: this.calculatePointsToRedeem(),
        pointsRate: this.getConversioRate(),
        mainTemplate: this.mainTemplate,
        pageIndex: this.pageLinkIndex,
        templateIndex: this.selectTabIndex,
        conversionType: config.showConversionValue ? config.conversionTypeTitle + "." : ".",
        currentTemplate:
          this.mainTemplate.template.pageLinks[this.pageLinkIndex]
            .templateSettings[this.selectTabIndex],
        styles: (
          this.mainTemplate.template.pageLinks[this.pageLinkIndex]
            .templateSettings[this.selectTabIndex]
            .configurations as unknown as RedemptionsConfigModel
        ).popUp,
      },
    });
  }

  public substractValue(value: string): void {
    if (this.redemptionAmountValue - Number(value) < 0) return;

    this.redemptionAmountValue -= Number(value);
  }

  public addMaxAmount() {
    if (this.isEmptyConversionRate) {
      return;
    }

    const { rateFrom, rateTo } = this.getConversioRate();
    const pointsRatio = rateFrom / rateTo;
    if (isNaN(pointsRatio) || pointsRatio <= 0) {
      return;
    }
    const maxAmount = Math.floor(
      this.profileService.playerAccountPointBalance / pointsRatio
    );
    this.redemptionAmountValue = Math.max(0, maxAmount); // prevent negative values
  }

  public getButtonStyle(v: any, tab: any, isRemoveButton: boolean) {
    const conversionRate = this.getConversioRate();
    const isConversionRateExists = Boolean(
      conversionRate.rateFrom && conversionRate.rateTo
    );
    const value = Number(v);
    const currentRedemptionValue = Number(this.redemptionAmountValue);

    let buttonStyleState: string;

    if (isRemoveButton) {
      buttonStyleState =
        currentRedemptionValue > 0 &&
        currentRedemptionValue - value >= 0 &&
        isConversionRateExists
          ? 'removeButton'
          : 'disabledremoveButton';
    } else {
      buttonStyleState =
        !this.isRedemptionValueMoreThanBalance(value) && isConversionRateExists
          ? 'addButton'
          : 'disabledAddButton';
    }

    const preSet = tab.configurations.preSets[buttonStyleState];
    const buttonColor =
      this.mainTemplate.globalVariables.buttonsColor[
        !isRemoveButton ? 'primaryColor' : 'secondaryColor'
      ];

    return this.styleService.getStyleRule(
      [preSet.text],
      [preSet.background, { color: buttonColor }],
      [preSet.border]
    );
  }

  public additionRedemptionAmount(value: string): void {
    if (
      this.isEmptyConversionRate ||
      this.isRedemptionValueMoreThanBalance(Number(value))
    ) {
      return;
    }

    this.redemptionAmountValue =
      Number(this.redemptionAmountValue) + Number(value);
  }

  private isRedemptionValueMoreThanBalance(value: number): boolean {
    return (
      this.calculateNeededPointsToRedeem(
        Number(this.redemptionAmountValue) + value
      ).pointsNeeded > this.profileService.playerAccountPointBalance
    );
  }

  public currencyInputChanged(value: string): void {
    var num = value.replace(/[$,]/g, '');
    this.redemptionAmountValue = Number(num);
  }

  public getTierRate(): { rateFrom: number | string; rateTo: number | string } {
    if (this.isEmptyConversionRate) {
      return { rateFrom: 'N/A', rateTo: 'N/A' };
    }
    return this.getConversioRate();
  }

  protected getConversioRate(): { rateFrom: number; rateTo: number } {
    const page =
      this.mainTemplate.template.pageLinks[this.pageLinkIndex].templateSettings[
        this.selectTabIndex
      ];

    if (page.templateName !== this.tabType.Redemptions) {
      return { rateFrom: 0, rateTo: 0 };
    }

    const tierLevelRate = this.getCurrentTierLevel();

    if (!tierLevelRate && !this.mainTemplate.tierLevels.isCmsValueInUse) {
      return { rateFrom: 0, rateTo: 0 };
    }

    const templateConfig =
      page.templateConfig as unknown as RedemptionTemplateConfigModel;
    const playerTierLevel = this.profileService.isUcSecondVersion
      ? this.playerProfile.club.currentClub
      : this.playerProfile.gamingInfo.tierLevel;

    if (templateConfig?.conversionRate === 'tiered') {
      const tierRates = templateConfig.tiredConversionRate as TierLevels[];

      if (
        tierLevelRate &&
        (tierLevelRate.status || (tierLevelRate.from && tierLevelRate.to))
      ) {
        const rate = tierRates.find((tier) => tier.guid === tierLevelRate.guid);
        return rate
          ? {
              rateFrom: Number(rate.rateFrom || 0),
              rateTo: Number(rate.rateTo || 0),
            }
          : { rateFrom: 0, rateTo: 0 };
      }

      const rateConfig = tierRates.find(
        (tier) =>
          tier.tierLevel === playerTierLevel.id ||
          tier.tierLevel === playerTierLevel.name
      );
      return rateConfig
        ? {
            rateFrom: Number(rateConfig.rateFrom),
            rateTo: Number(rateConfig.rateTo),
          }
        : { rateFrom: 0, rateTo: 0 };
    }

    return {
      rateFrom: Number(templateConfig.rateFrom),
      rateTo: Number(templateConfig.rateTo),
    };
  }

  protected getCurrentTierLevel(): Tier | void {
    if (this.mainTemplate.tierLevels.isCmsValueInUse) {
      return undefined;
    }

    const tiers = this.mainTemplate.tierLevels.tiers;
    const lastTier = tiers.at(-1);

    const playerPointsBalance = Number(
      String(this.profileService
        .fallBackDataPointValues()
        .pointBalance ?? 0).replaceAll(',', '')
    );

    if (
      lastTier &&
      (lastTier.to === 0 || playerPointsBalance > (lastTier.to ?? 0))
    ) {
      return lastTier;
    }

    const currentTier = tiers.find((tier, index) => {
      const effectiveTierTo =
        tier.to === 0 || (isNaN(tier.to) && index === tiers.length - 1)
          ? 9999999999
          : tier.to;
      return (
        tier.from <= playerPointsBalance &&
        playerPointsBalance <= effectiveTierTo
      );
    });

    return currentTier;
  }

  public getConversionType(): { title: string; value: string } | void {
    const tab = this.mainTemplate.template.pageLinks[this.pageLinkIndex]
      .templateSettings[this.selectTabIndex] as any;

    if (!tab?.templateConfig?.conversionType) return;

    return this.conversionType.find((v) => {
      return v.value === tab.templateConfig.conversionType;
    });
  }

  public getRedemptionInformationHtml(html: string): SafeHtml | void {
    if (!html) return;

    const valuesToChange = [
      {
        templateVariable: '{{conversionRateFrom}}',
        templateVariableValue: this.getTierRate().rateFrom,
      },
      {
        templateVariable: '{{conversionRateTo}}',
        templateVariableValue: this.getTierRate().rateTo,
      },
      {
        templateVariable: '{{conversionType}}',
        templateVariableValue: this.getConversionType()?.title,
      },
    ];

    valuesToChange.forEach((value) => {
      html = html.replace(
        value.templateVariable,
        String(value.templateVariableValue)
      );
    });

    this.appendRedemptionStyles();

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  private appendRedemptionStyles(): void {
    const tab = this.mainTemplate.template.pageLinks[this.pageLinkIndex]
      .templateSettings[this.selectTabIndex] as any;

    if (document.getElementById('redemptionStyles')) return;

    if (this.styleService.isQt3Kiosk) {
      if (tab?.templateConfig?.description?.css) {
        tab.templateConfig.description.css =
          this.styleService.dividePixelStylesByTwo(
            tab?.templateConfig?.description?.css
          );
      }
    }

    const styles = tab?.templateConfig?.description?.css;
    const body = document.getElementsByTagName('body')[0];
    const style = document.createElement('style');

    style.id = 'redemptionStyles';
    style.type = 'text/css';
    style.appendChild(document.createTextNode(styles));
    body.appendChild(style);
  }

  protected async adjustingRedemptionValues() {
    return new Promise(async (resolve, reject) => {
      this.transactionVoucherId = uuid.v4();
      const transactionDateTime = new Date();
      const config = this.mainTemplate.template.pageLinks[this.pageLinkIndex]
        .templateSettings[this.selectTabIndex].templateConfig as any;

      //capture requested values before balance is manually updated post-withdraw
      const requestedConversionAmount = this.redemptionAmountValue;
      const requestedBalanceDeduction = this.calculatePointsToRedeem();

      const baseLogModel = {
        externalId: this.profileService.playerProfile.playerId,
        transactionType: 2,
        sourceBucket: this.sourceBucket,
        balanceDeduction: requestedBalanceDeduction,
        conversionAmount: requestedConversionAmount,
        conversionType: config?.conversionType ?? this.selectedRedeem,
        conversionLabel: config?.conversionTypeTitle ?? this.selectedRedeem,
        voucherID: this.transactionVoucherId,
        firstName: this.profileService.isUcSecondVersion
          ? this.profileService.playerProfile.playerProfile?.firstName
          : this.profileService.playerProfile.name?.first,
        lastName: this.profileService.isUcSecondVersion
          ? this.profileService.playerProfile.playerProfile?.lastName
          : this.profileService.playerProfile.name?.last,
        kioskId: this.authService.kioskId ?? '',
        kioskName: this.authService.preparedKioskDeviceId,
        transactionDateTime,

        rateFrom: this.getConversioRate().rateFrom,
        rateTo: this.getConversioRate().rateTo,
      };

      let statusLog = '';

      //production trace for V1 redemption
      this.logService.writeLog(
        `[RedemptionV1] adjustingRedemptionValues:start :: playerId=${this.playerProfile?.playerId}, amount=${this.redemptionAmountValue}, sourceBucket=${this.sourceBucket}, selectedRedeem=${this.selectedRedeem}`,
        LogType.ERROR,
        LogSource.REDEMPTION
      );

      const onBadRequest = async (msg: string) => {
        this.redemptionAmountValue = 0;
        this.isLoading = false;

        this.snackbar.openFromComponent(SnackbarComponent, {
          panelClass: 'error',
          duration: 3000,
          horizontalPosition: 'end',
          data: {
            type: 'error',
            message: msg,
          },
        });

        try {
          //postTransactionLog in onBadRequest has no timeout - if log service is down this hangs and reject(msg) never fires
          await Promise.race([
            this.transactionLogService.postTransactionLog({
              ...baseLogModel,
              redemptionStatus: 9,
              statusMessage: statusLog + `Failed: ${msg}`,
              webhookStatus: 4,
            }),
            new Promise((_, reject) => setTimeout(() => reject(new Error('postTransactionLog timeout')), 8000))
          ]);
        } catch (logErr) {
          this.logService.writeLog(
          `[RedemptionV1] postTransactionLog failed non-blocking :: playerId=${this.profileService?.playerProfile?.playerId}, voucherID=${this.transactionVoucherId}, error=${(logErr as any)?.message ?? JSON.stringify(logErr)}`,
          LogType.ERROR,
          LogSource.REDEMPTION
        );

          //save failed transaction log locally so it can be retried when browser is online again
          let pendingLogs: any[] = [];

          try {
            pendingLogs = JSON.parse(localStorage.getItem('pendingTransactionLogs') ?? '[]');
          } catch {
            pendingLogs = [];
          }

          pendingLogs.push({
            ...baseLogModel,
            redemptionStatus: 9,
            statusMessage: statusLog + `Failed: ${msg}`,
            webhookStatus: 4,
            createdAt: new Date().toISOString()
          });

          localStorage.setItem('pendingTransactionLogs', JSON.stringify(pendingLogs));
        }

        this.printService.setIsPrinting(
          false,
          'Redemption adjustingRedemptionValues onBadRequest',
        );
        reject(msg);
      };
      
      this.isLoading = true;
      //moving print state control to confirm-redeem-modal, same as V2
      //this.printService.setIsPrinting(true, "Redemption adjustingRedemptionValues");
    

      let adjRes: any;
      try {
          adjRes = await Promise.race([
            this.profileService.doBalanceAdjustment(
              this.playerProfile?.playerId,
              requestedBalanceDeduction,
              this.sourceBucket,
              'D',
              null,
              "",
              this.dailyLimit,
              this.redemptionAmountValue.toString(),
              this.accountId
            ),
            new Promise((_, reject) => setTimeout(() => reject(new Error('withdraw timeout')), 30000))
          ]);
        } catch (networkErr: any) {
          this.logService.writeLog(
            `[RedemptionV1] withdraw:exception :: playerId=${this.playerProfile?.playerId}, error=${networkErr?.message ?? JSON.stringify(networkErr)}`,
            LogType.ERROR,
            LogSource.REDEMPTION
          );

    //normalize ugly profile.service crash message into a clean timeout message
    const isTimeoutOrCrash = !networkErr?.message || networkErr?.message?.includes('Cannot read properties') || networkErr?.message?.includes('timeout');
    await onBadRequest(isTimeoutOrCrash ? 'Network error: no response from server' : (networkErr?.message ?? 'Network error: no response from server'));
    return;
  }

      this.logService.writeLog(
      `[RedemptionV1] withdraw:response :: playerId=${this.playerProfile?.playerId}, response=${JSON.stringify(adjRes)}`,
      LogType.ERROR,
      LogSource.REDEMPTION
    );

      //UC v2 returns errors in message/errors[]/result fields instead of status/errorDetails.
      // Must check before the freePlay block, otherwise a failed withdraw with UC v2 error shape
      // would pass the !adjRes.status && !adjRes.error condition and incorrectly enter the deposit block.
      // Also treats null/empty response as error (UC timeout/disconnect returns {status:null, error:null}).
      // exclude 'ok' success marker from being treated as UC v2 error message
      const ucV2ErrorMsg = !adjRes?.status && !adjRes?.error
        ? (adjRes?.message || adjRes?.errors?.[0]?.message || (typeof adjRes?.result === 'string' && adjRes.result.length > 0 && adjRes.result !== 'ok' ? adjRes.result : null) || null)
        : null;
      const effectiveError = adjRes?.error || adjRes?.errorDetails || ucV2ErrorMsg || null;
      const effectiveStatus = adjRes?.status || null;
      // for UC v2, a response with no status/error/result is a silent success (transactionId only, message stripped by UC directive)
      const isUcV2SilentSuccess = this.profileService.isUcSecondVersion && !effectiveError && !effectiveStatus && adjRes?.result === undefined;
      
      //V1 UC returns raw transaction object with no result field - must check for id to detect success
      const isV1TransactionSuccess = !this.profileService.isUcSecondVersion && !!adjRes?.id && !effectiveError && !effectiveStatus;

      
      const withdrawFailed = !isUcV2SilentSuccess && !isV1TransactionSuccess && (effectiveError || effectiveStatus ||
        (!effectiveError && !effectiveStatus && !adjRes?.result));

      
      if (withdrawFailed) {
        await onBadRequest(effectiveStatus || effectiveError || 'No response from server');
        return;
      }

      if (
  this.getConversionType()?.value === ConversionType.freePlay &&
  !adjRes.status && !adjRes.error
) {
  statusLog += 'Withdraw completed. ';

  let res: any;

  try {
    res = await Promise.race([
      this.profileService.doBalanceAdjustment(
        this.playerProfile?.playerId,
        this.redemptionAmountValue,
        this.selectedRedeem,
        'C',
        null,
      ),
      new Promise((_, reject) => setTimeout(() => reject(new Error('freePlay deposit timeout')), 8000))
    ]);
  } catch (depositErr: any) {
    statusLog += 'Deposit failed/no response. MANUAL INTERVENTION REQUIRED. ';
    await onBadRequest(depositErr?.message ?? 'Network error: no response from server');
    return;
  }

  const depositError = res?.status || res?.error || res?.errorDetails || res?.message || res?.errors?.[0]?.message || null;
    
  if (depositError) {
    let rollbackRes: any;

    try {
      rollbackRes = await Promise.race([
        this.profileService.doBalanceAdjustment(
          this.playerProfile?.playerId,
          requestedBalanceDeduction,
          this.sourceBucket,
          'C',
          null,
          "",
          this.dailyLimit,
          this.redemptionAmountValue.toString(),
          this.accountId,
        ),
        new Promise((_, reject) => setTimeout(() => reject(new Error('rollback timeout')), 8000))
      ]);
    } catch (rollbackErr: any) {
      statusLog += 'Rollback failed/no response. MANUAL INTERVENTION REQUIRED. ';
      await onBadRequest(depositError);
      return;
    }

    if (rollbackRes?.error || rollbackRes?.status) {
      statusLog += 'Rollback failed. MANUAL INTERVENTION REQUIRED. ';
    } else {
      statusLog += 'Withdraw rolled back. ';
    }

    await onBadRequest(depositError);
    return;
  }

  statusLog += 'Deposit completed. ';
}

      if (
        this.profileService.isUcSecondVersion &&
        this.profileService.playerBalances?.a_Points.amount
      ) {
        this.profileService.playerBalances.a_Points.amount =
          this.profileService.playerBalances?.a_Points.amount -
          requestedBalanceDeduction;
      } else {
        this.playerProfile.gamingInfo.PlayerAccountBalance =
          this.playerProfile?.gamingInfo?.PlayerAccountBalance -
          requestedBalanceDeduction;
      }

      const completedConversionAmount = requestedConversionAmount;
      const completedBalanceDeduction = requestedBalanceDeduction;

      this.redemptionAmountValue = 0;

      //getPlayerBalance has no timeout/catch - if it hangs resolve(true) never fires after successful withdraw
      try {
        await Promise.race([
          this.profileService.getPlayerBalance(this.playerProfile.playerId),
          new Promise((_, reject) => setTimeout(() => reject(new Error('getPlayerBalance timeout')), 8000))
        ]);
      } catch (balErr) {
        this.logService.writeLog(
        `[RedemptionV1] getPlayerBalance:failed non-blocking :: playerId=${this.playerProfile?.playerId}, error=${(balErr as any)?.message ?? JSON.stringify(balErr)}`,
        LogType.ERROR,
        LogSource.REDEMPTION
      );
      
      }
      this.isLoading = false;
      //moving print state control to confirm-redeem-modal, same as V2
      //this.printService.setIsPrinting(false, "Redemption adjustingRedemptionValues success");

      try {
        //postTransactionLog has no timeout - if it hangs resolve(true) never fires after successful withdraw
        await Promise.race([
          this.transactionLogService.postTransactionLog({
            ...baseLogModel,
            redemptionStatus: 8,
            statusMessage:
              'Success: Withdraw completed.' +
              (this.getConversionType()?.value === ConversionType.freePlay
                ? ' Deposit completed.'
                : ''),
            conversionAmountCompleted: completedConversionAmount,
            balanceDeductionCompleted: completedBalanceDeduction,
            webhookStatus: 3,
          }),
          new Promise((_, reject) => setTimeout(() => reject(new Error('postTransactionLog timeout')), 8000))
        ]);

        this.logService.writeLog(
        `[RedemptionV1] postTransactionLog:success completed :: playerId=${this.profileService?.playerProfile?.playerId}, voucherID=${this.transactionVoucherId}`,
        LogType.ERROR,
        LogSource.REDEMPTION
      );

      } catch (logErr) {
        this.logService.writeLog(
          `[RedemptionV1] postTransactionLog failed non-blocking :: playerId=${this.profileService?.playerProfile?.playerId}, voucherID=${this.transactionVoucherId}, error=${(logErr as any)?.message ?? JSON.stringify(logErr)}`,
          LogType.ERROR,
          LogSource.REDEMPTION
        );

        //save successful transaction log locally so it can be retried when browser is online again
        let pendingLogs: any[] = [];

        try {
          pendingLogs = JSON.parse(localStorage.getItem('pendingTransactionLogs') ?? '[]');
        } catch {
          pendingLogs = [];
        }

        pendingLogs.push({
          ...baseLogModel,
          redemptionStatus: 8,
          statusMessage:
            'Success: Withdraw completed.' +
            (this.getConversionType()?.value === ConversionType.freePlay
              ? ' Deposit completed.'
              : ''),
          conversionAmountCompleted: completedConversionAmount,
          balanceDeductionCompleted: completedBalanceDeduction,
          webhookStatus: 3,
          createdAt: new Date().toISOString()
        });

        localStorage.setItem('pendingTransactionLogs', JSON.stringify(pendingLogs));
      }

      resolve(true);
    });
  }

  public calculatePointsToRedeem(): number {
    const { pointsNeeded, accountBalance } = this.calculateNeededPointsToRedeem(
      this.redemptionAmountValue
    );

    return pointsNeeded > accountBalance ? 0 : pointsNeeded;
  }

  protected calculateNeededPointsToRedeem(dollarsValue: number): {
    pointsNeeded: number;
    accountBalance: number;
  } {
    const accountBalance = this.profileService.playerAccountPointBalance;
    if (this.isEmptyConversionRate) {
      return { pointsNeeded: 0, accountBalance };
    }

    const { rateFrom, rateTo } = this.getConversioRate();
    const pointsRatio = rateFrom / rateTo;
    const pointsNeeded = Math.ceil(dollarsValue * pointsRatio);

    return { pointsNeeded, accountBalance };
  }

  protected openInfoBlock(
    title: string,
    text: string,
    css: string,
    callback?: Function
  ): void {
    this.dialog.open(InfoModalComponent, {
      panelClass: 'profile-dialog',
      backdropClass: 'backDropClass',
      width: '100vw',
      data: {
        callback: async () => {
          if (callback) {
            await callback();
          }
        },
        title,
        text,
        css,
        styles: (
          this.mainTemplate.template.pageLinks[this.pageLinkIndex]
            .templateSettings[this.selectTabIndex]
            .configurations as unknown as RedemptionsConfigModel
        ).popUp,
        mainTemplate: this.mainTemplate,
      },
    });
  }
}